/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ToolVariation = {
  /**
   * The confirmation mode for the tool variation
   */
  confirm?: string | undefined;
  /**
   * The confirmation prompt for the tool variation
   */
  confirmPrompt?: string | undefined;
  /**
   * The creation date of the tool variation
   */
  createdAt: string;
  /**
   * The description of the tool variation
   */
  description?: string | undefined;
  /**
   * Override: if true, the tool may perform destructive updates
   */
  destructiveHint?: boolean | undefined;
  /**
   * The ID of the tool variation group
   */
  groupId: string;
  /**
   * The ID of the tool variation
   */
  id: string;
  /**
   * Override: if true, repeated calls have no additional effect
   */
  idempotentHint?: boolean | undefined;
  /**
   * The name of the tool variation
   */
  name?: string | undefined;
  /**
   * Override: if true, the tool interacts with external entities
   */
  openWorldHint?: boolean | undefined;
  /**
   * Override: if true, the tool does not modify its environment
   */
  readOnlyHint?: boolean | undefined;
  /**
   * The name of the source tool
   */
  srcToolName: string;
  /**
   * The URN of the source tool
   */
  srcToolUrn: string;
  /**
   * The summarizer of the tool variation
   */
  summarizer?: string | undefined;
  /**
   * The tags of the tool variation
   */
  tags?: Array<string> | undefined;
  /**
   * Display name override for the tool
   */
  title?: string | undefined;
  /**
   * The last update date of the tool variation
   */
  updatedAt: string;
};

/** @internal */
export const ToolVariation$inboundSchema: z.ZodMiniType<
  ToolVariation,
  unknown
> = z.pipe(
  z.object({
    confirm: z.optional(z.string()),
    confirm_prompt: z.optional(z.string()),
    created_at: z.string(),
    description: z.optional(z.string()),
    destructive_hint: z.optional(z.boolean()),
    group_id: z.string(),
    id: z.string(),
    idempotent_hint: z.optional(z.boolean()),
    name: z.optional(z.string()),
    open_world_hint: z.optional(z.boolean()),
    read_only_hint: z.optional(z.boolean()),
    src_tool_name: z.string(),
    src_tool_urn: z.string(),
    summarizer: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    title: z.optional(z.string()),
    updated_at: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "confirm_prompt": "confirmPrompt",
      "created_at": "createdAt",
      "destructive_hint": "destructiveHint",
      "group_id": "groupId",
      "idempotent_hint": "idempotentHint",
      "open_world_hint": "openWorldHint",
      "read_only_hint": "readOnlyHint",
      "src_tool_name": "srcToolName",
      "src_tool_urn": "srcToolUrn",
      "updated_at": "updatedAt",
    });
  }),
);

export function toolVariationFromJSON(
  jsonString: string,
): SafeParseResult<ToolVariation, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolVariation$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolVariation' from JSON`,
  );
}
